import uuid from "uuid";
import notification from "utils/Notification/notification";
import jwt_decode from 'jwt-decode'
import moment from 'moment-jalaali'
import {
  getDayNumber, getDayName,
  getDayTitle, getDayNameByIndexnoti
} from 'utils/persianUtils'



export function objectWithoutProperties(obj, ...keys) {
  let target = {};
  for (let key in obj) {
    if (keys.indexOf(key) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
    target[key] = obj[key];
  }
  return target;
}

export const getSelectedCode = (items, value, key) => {
  if (
    handleNullArray(items).length == 0 ||
    checkNull(value) ||
    checkNull(key)
  ) {
    return null;
  } else {
    return handleNullArray(items).find(
      (item) =>
        item[key].toString().toLowerCase() === value.toString().toLowerCase()
    );
  }
};


export function makeRandomString(len) {
  var str = "";                                // String result
  for (var i = 0; i < len; i++) {              // Loop `len` times
    var rand = Math.floor(Math.random() * 62); // random: 0..61
    var charCode = rand += rand > 9 ? (rand < 36 ? 55 : 61) : 48; // Get correct charCode
    str += String.fromCharCode(charCode);      // add Character to str
  }
  return str; // After all loops are done, return the concatenated string
}

// export function objectWithoutProperties2(obj, ...keys) { 
//     let target = {}; 
//     for (let key in obj) { 
//             if (keys.indexOf(key) >= 0) continue; 
//             if (!Object.prototype.hasOwnProperty.call(obj, key)) continue; 
//             target[key] = obj[key]; 
//         } 
//     return target; 
// }

export function getNumbersFromString(text) {
  return text.replace(/[^0-9^.]/g,'');
}

export function extendClass(target) {
  for (let i = 1; i < arguments.length; i++) {
    let source = arguments[i];
    for (let key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

export function extendClass2(target, ...args) {
  for (let i = 1; i < args; i++) {
    let source = arguments[i];
    for (let key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

export function mergeObjects(object1, object2) {
  return Object.assign(object1, object2);
}

export function objectToArray(obj) {
  return Object.keys(obj).map(key => {
    return obj[key];
  })
}

export function objectToPropertyArray(obj) {
  return Object.entries(obj).map(( [k, v]) => ({ [k]: v}));
}

export function capitalizeFirstCharacter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function readFileDataAsByte64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      resolve(event.target.result);
    }

    reader.onerror = (err) => {
      reject(err);
    }

    reader.readAsBinaryString(file);
  })

}




var globalCssModule;

// function setGlobalCssModule(cssModule) {
//   globalCssModule = cssModule;
// }

export function mapToCssModules(className, cssModule) {
  if (className === void 0) {
    className = '';
  }

  if (cssModule === void 0) {
    cssModule = globalCssModule;
  }

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

export function newV4Id() {
  return uuid.v4();
}

export function isTokenValid (token) {
  let decoddedToken = jwt_decode(token);
  let currentDate = new Date();
  if (decoddedToken.exp * 1000 < currentDate.getTime()){
    return true;
  } else {
    return false;
  }
}

export const randomNum = (min = 0, max = 1000) => {
  return min + (Math.random() * (max - min));
};

export function checkNull(value) {
  if (value === undefined || value === null || value === '')
    return true;

  return false;
}

export function areObjectsEquals(object1, object2) {
  return JSON.stringify(object1) === JSON.stringify(object2);
}

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function notifySuccess (message) {
  notification({ width: `${message.width}`, timeout: message.timeout }).success(message.message);
};

export function notifyError (message) {
  notification({ width: `${message.width}`, timeout: message.timeout }).failure(message.message);
};

export function notifyWarning (message) {
  notification({ width: `${message.width}`, timeout: message.timeout }).warning(message.message);
};

export function notifyConfirm (message) {
  notification({ width: `${message.width}`, timeout: message.timeout }).confirm(message.message)
};

export function notifyInfo (message) {
  notification({ width: `${message.width}`, timeout: message.timeout }).info(message.message)
};
// Notiflix.Confirm.Show('Notiflix Confirm','Do you agree with me?','Yes','No',function(){ // Yes button callbackalert('Thank you.');},function(){ // No button callbackalert('If you say so...');});

export function handleMessages(result, timeout=5000) {
  handleNullArray(result.messages).map((item, index) => {
    if (item.messageType === "Success") {
      notifySuccess({
        width: !checkNull(item.width) ? `${item.width}px` : "500px",
        message: item.message,
        timeout: timeout
      });
    } else if (item.messageType === "Error") {
      notifyError({
        width: !checkNull(item.width) ? `${item.width}px` : "500px",
        message: item.message,
        timeout: timeout
      });
    } else {
      notifyWarning({
        width: "550px",
        message: item.message,
        timeout: timeout
      });
    }
  })
}

export function handleErrorList(errors) {
  notifyError({
    width: "400px",
    message: "ذخیره اطلاعات با خطا مواجه و جلسه ذخیره نگردید",
  });
}

export function isObject(object) {
  return typeof object == 'object';
}

export function isArray(object) {
  return Array.isArray(object)
}

export function isObjectNull(object) {
  return object === null || object === undefined ? true : Object.keys(object).length === 0 && object.constructor === Object;
}

export function getEmptyObjectFromNull(object) {
  return (isObjectNull(object) || checkNull(object)) ? {} : object;
}

export function handleNullArray(inArray) {
  return (!Array.isArray(inArray) || inArray === null || inArray === undefined) ? [] : inArray
}

export function isArrayEmpty(array) {
  return !array || array.length === 0 ? true : false
}

export function replaceEmptyWithNull(value) {
  return value === '' ? null : value;
}

export function replaceEmptyOrUndefinedWithNull(value) {
  return checkNull(value) ? null : value;
}

export function handleNull(value) {
  if (checkNull(value))
    return '';

  return value;
}

export function removeDuplicates (arr) {
  return [...new Set(arr)];
}

export function removeDuplicateObjects(arr) { 
  let jsonObject = arr.map(JSON.stringify);
  let uniqueSet = new Set(jsonObject);
  return Array.from(uniqueSet).map(JSON.parse);

}

export function makeColor() {
  // let colors = ['#ff8000', '#0080ff','#FF7F50','#DE3163','#9FE2BF','#6495ED','#C0C0C0','#FF0000',
  //               '#FFFF00','#000080','#800080','#FF6347','#FFA500','#FF4500','#EE82EE','#9932CC',
  //               '#32CD32','#2E8B57','#20B2AA','#48D1CC','#1E90FF','#D2B48C','#D2691E','#A52A2A',
  //               '#00A36C','#ADD8E6','#D27D2D','#9A2A2A','#C04000','#899499','#848884','#50C878',
  //               '#355E3B','#DAA520','#E35335','#FA8072','#FFAA33','#9F2B68','#FF7F50','#F88379',
  //               '#FF69B4','#DA70D6','#A95C68','#953553','#E0115F','#E37383','#E0B0FF','#6F8FAF',
  //               '#6082B6','#8A2BE2','#5F9EA0','#DEB887','#008B8B','#556B2F','#8B0000','#8FBC8F',
  //               '#483D8B','#2F4F4F','#FF1493','#696969','#DCDCDC','#CD5C5C','#4B0082','#F0E68C',
  //               '#F08080','#20B2AA','#48D1CC','#FF4500','#CD853F','#663399','#8B4513','#A0522D',
  //               '#4682B4','#FF6347'];
  let colors = ['tomato', 'orange','dodgerblue','mediumseagreen','gray','slateblue','violet','lightGray',
                '#ff66d9','#ff0000','#00b300','#9900cc']
  //  return colors[Math.floor(randomNum(0,11))];
  return 'dodgerblue'

}

export function makeRandomColor(num) {
  // let colors = ['dodgerblue','mediumseagreen','gray','slateblue','lightGray','#00b300']
  // return colors[Math.floor(randomNum(0,5))];
  let colors = [
    'slateblue','dodgerblue','#00b300',
    '#6b5b95','#d64161','#ff7b25', 
    '#8d9db6','#eea29a','#E37383',
    '#dac292', 'lightGray', 'mediumseagreen', 
    '#e06377','#622569','#96ceb4',     
    '#f7786b', '#50394c', 
    '#618685','#bc5a45','#92a8d1',
    '#33f3ff'
  ]
  // let index = Math.floor(randomNum(0, num));
  return colors[num];
}

export function makeFontColor(num, step) {
  let colors = [];
  if (step === 1) {
    colors = [
      '#000080','#000080','#FFFF00',
      '#FFFF00','#FFFF00','#FFFF00', 
      '#FFFF00','#FFFF00','#000080',
      '#FFFF00','#FFFF00','#FFFF00', 
      '#FFFFFF','#FFFF00','#FF0000',     
      '#FFFF00','#eb9d02','#eb02e3',
      '#FFFF00','#000080','#000080'
    ]
  } else if (step === 2) {
    colors =  [
      '#FFFFFF','#FFFFFF','#000080',
      '#000080','#FFFFFF','#000080', 
      '#000080','#000000','#ffff33',
      '#000000','#000000','#0000A3', 
      '#14f799','#268CD9','#FF0000',     
      '#000000','#eb9d02','#02eb1a',
      '#000000','#000000','#000000'
    ]
  } else {
    return "#000080";  
  }
  return colors[num];  
}


export function saveStorage(key, value) {
  if (checkNull(key))
    return false;

  var currentValue = getStorage(key);
  if (currentValue != value) {
    localStorage.removeItem(key);
    localStorage.setItem(key, value);
  }
  return true;
}

export function getStorage(key) {
  return localStorage.getItem(key);
}

export function convertMinuteToRightTime(minute) {
  var hours = Math.floor(minute / 60);
  var mins = minute % 60;
  return hours + ":" + mins;
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
 }
// export function handleResponse(response) {
//     return response.text().then(text => {
//         const data = text && JSON.parse(text);
//         if (!response.ok) {
//             if (response.status === 401) {
//                 // auto logout if 401 response returned from api
//                 logout();
//                 location.reload(true);
//             }

//             const error = (data && data.message) || response.statusText;
//             return Promise.reject(error);
//         }

//         return data;
//     });
// }